import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import styled, { keyframes } from "styled-components";
import axios from 'axios';
import { FaInfoCircle } from 'react-icons/fa';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AlertCircleIcon, CheckCircleIcon } from "lucide-react";

const ContactSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [success,setSuccess]= useState("");
  const [error, setError]= useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const section = document.getElementById("contact-section");
      if (section) {
        const rect = section.getBoundingClientRect();
        setIsVisible(rect.top < window.innerHeight && rect.bottom >= 0);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); 
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Get form data and request api 
  const handleSubmit = (e) => {
    setLoading(true);
    e.preventDefault();

    const data = {
      "firstname": firstname, // Correction de "firtname"
      "lastname": lastname,
      "phone": phone,
      "email": email,
      "subject": subject,
      "message": message,
    };
    // console.log(data);

    axios.post( process.env.React_App_base_url + 'contact', {         
        "firstname": firstname, // Correction de "firtname"
        "lastname": lastname,
        "phone": phone,
        "email": email,
        "subject": subject,
        "message": message,
      
    })
    .then(response => {
      const successRes = response.data.success;
      if (successRes === true) {
        setLoading(false);
        setSuccess("Message envoyé avec succès");
        setError(""); // Réinitialisation du message d'erreur
      } else {
        setLoading(false);
        setError("Message non envoyé. Veuillez rééssayer en remplissant tous les champs");
        setSuccess(""); // Réinitialisation du message de succès
      }
    })
    .catch(error => {
      setLoading(false);
      setError("Une erreur est survenue lors de l'envoi du message. Veuillez remplir tous les champs et réessayer.");
      setSuccess(""); // Réinitialisation du message de succès
      // console.error("Erreur lors de l'envoi du message :", error);
    });
};

// Loading on click
if (loading===true) {
  return (
     <p
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        fontSize: "24px",
        fontWeight: "bold",
        color: "rgba(29, 14, 249, 0.8)",
        backgroundColor: "rgba(255, 255, 255, 0.8)",
        borderRadius: "5px",
        padding: "10px 20px",
        cursor: "default",
      }}
    >
      {" "}
      <span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
        >
          <g
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          >
            <path
              stroke-dasharray="16"
              stroke-dashoffset="16"
              d="M12 3c4.97 0 9 4.03 9 9"
            >
              <animate
                fill="freeze"
                attributeName="stroke-dashoffset"
                dur="0.3s"
                values="16;0"
              />
              <animateTransform
                attributeName="transform"
                dur="1.5s"
                repeatCount="indefinite"
                type="rotate"
                values="0 12 12;360 12 12"
              />
            </path>
            <path
              stroke-dasharray="64"
              stroke-dashoffset="64"
              stroke-opacity="0.3"
              d="M12 3c4.97 0 9 4.03 9 9c0 4.97 -4.03 9 -9 9c-4.97 0 -9 -4.03 -9 -9c0 -4.97 4.03 -9 9 -9Z"
            >
              <animate
                fill="freeze"
                attributeName="stroke-dashoffset"
                dur="1.2s"
                values="64;0"
              />
            </path>
          </g>
        </svg>{" "}
      </span>{" "}
      <span>Loading...</span>{" "}
    </p>
  );
}

  

  return (
    <Section id="contact-section" className={isVisible ? "visible" : ""}>
      <Container>
        <LeftSide>
            {/* display success message */}
            {success && <p style={{ color: "green", textAlign:"center", fontSize:14, marginTop:'12px' }}> <CheckCircleIcon /> {success}</p>}
            {error && <p style={{ color: "red", textAlign:"center", fontSize:18,marginTop:'12px' }}><AlertCircleIcon/> {error}</p>}
          <Title>Contactez-nous</Title>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Input onChange={(e) => setFirstname(e.target.value)} name="firstname" type="text" placeholder="Prénom" />
              <Input onChange={(e) => setLastname(e.target.value)} name="lastname" type="text" placeholder="Nom" />
            </Row>
            <Input onChange={(e) => setPhone(e.target.value)}  type="tel" name="phone" placeholder="Entrez votre numéro de téléphone" />
            <Input onChange={(e) => setEmail(e.target.value)}  type="email" name="email" placeholder="Entrez votre e-mail" />
            <Input onChange={(e) => setSubject(e.target.value)}  type="text" name="subject" placeholder="Entrez l'objet du mail" />
            <Textarea onChange={(e) => setMessage(e.target.value)} name="message"  placeholder="Écrivez votre message..." />
            <Button type="submit">Envoyer</Button>
          </Form>            
        </LeftSide>
        <RightSide>
          <Image src="../assets/images/image13.png" alt="Équipe professionnelle" />
        </RightSide>
      </Container>
    </Section>
  );
};

export default ContactSection;


const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;


const Section = styled.section`
  background: #fff;
  display: flex;
  justify-content: center;
  padding: 60px 20px;
  opacity: 0;
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
  &.visible {
    opacity: 1;
    animation: ${fadeIn} 1s ease-in-out;
  }

  @media (max-width: 991px) {
    padding: 50px 15px;
  }

  @media (max-width: 768px) {
    padding: 40px 10px;
  }

  @media (max-width: 576px) {
    padding: 30px 5px;
  }
`;

const Container = styled.div`
  display: flex;
  max-width: 1000px;
  width: 100%;
  background: #f9f9f9;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    flex-direction: column;
    margin: 0 10px;
  }

  @media (max-width: 576px) {
    border-radius: 5px;
    margin: 0 5px;
  }
`;

const LeftSide = styled.div`
  flex: 1;
  padding: 50px;

  @media (max-width: 991px) {
    padding: 40px;
  }

  @media (max-width: 768px) {
    padding: 30px;
  }

  @media (max-width: 576px) {
    padding: 25px 20px;
  }

  @media (max-width: 400px) {
    padding: 20px 15px;
  }
`;

const RightSide = styled.div`
  flex: 1;
  background: #ddd;

  @media (max-width: 768px) {
    min-height: 200px;
    order: -1;
  }

  @media (max-width: 576px) {
    min-height: 150px;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Title = styled.h2`
  font-size: 40px;
  font-weight: bold;
  background: linear-gradient(to right, #e60000, #ffcc00); 
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: left; 
  margin-bottom: 25px;

  @media (max-width: 991px) {
    font-size: 36px;
    margin-bottom: 20px;
  }

  @media (max-width: 768px) {
    font-size: 32px;
    text-align: center;
    margin-bottom: 18px;
  }

  @media (max-width: 576px) {
    font-size: 28px;
    margin-bottom: 15px;
  }

  @media (max-width: 400px) {
    font-size: 24px;
  }
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const Row = styled.div`
  display: flex;
  gap: 10px;

  @media (max-width: 576px) {
    flex-direction: column;
    gap: 0;
  }
`;

const Input = styled.input`
  flex: 1;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
  margin-bottom: 15px;

  @media (max-width: 576px) {
    padding: 10px;
    font-size: 15px;
    margin-bottom: 12px;
  }

  @media (max-width: 400px) {
    padding: 8px;
    font-size: 14px;
  }
`;

const Textarea = styled.textarea`
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
  min-height: 100px;
  margin-bottom: 15px;
  resize: none;

  @media (max-width: 576px) {
    padding: 10px;
    font-size: 15px;
    min-height: 80px;
    margin-bottom: 12px;
  }

  @media (max-width: 400px) {
    padding: 8px;
    font-size: 14px;
    min-height: 70px;
  }
`;

const Button = styled.button`
  background: linear-gradient(to right, #e60000, #ffcc00); 
  color: white;
  font-size: 14px;
  font-weight: bold;
  padding: 10px;
  width: 150px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;
  
  &:hover {
    opacity: 0.9;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 12px;
    font-size: 16px;
  }

  @media (max-width: 576px) {
    padding: 10px;
    font-size: 15px;
  }

  @media (max-width: 400px) {
    padding: 8px;
    font-size: 14px;
  }
`;
